import AccountingDocumentWidget from "../../shared/documentInfrastructure/AccountingDocumentWidget.js";
import SearchFormWidget from "../widgets/SearchFormWidget/SearchFormWidget.js";
import SearchResultsWidget from "../widgets/SearchResultsWidget/SearchResultsWidget.js";

/**
 * Renders a search form for the user to specify search criteria and
 * search results matching this criteria.
 */
export default class SearchDocumentContent extends AccountingDocumentWidget {
	setup() {
		super.setup(...arguments);

		this._searchForm = new SearchFormWidget({
			searchPeriod: this._documentState.getSearchPeriod(),
			onSearchRequest: async (query) => {
				this._searchResultsWidget.setSearchResult({
					results: await this._documentState.searchLedger(query),
					period: query.searchPeriod,
				});
			},
		});

		this._searchResultsWidget = new SearchResultsWidget({
			company: this._documentState.getCompany(),
		});
	}

	renderContentOn(html) {
		html.div(
			{ class: "SearchDocumentContent" },
			this._searchForm,
			this._searchResultsWidget,
		);
	}
}
